'use es6';

import { isNullOrUndefined } from 'ContentUtils/helpers/ObjectHelpers';
const DEFAULT_IMAGES_PATH = 'https://static.hsstatic.net/TemplateAssets/static-1.32/img/hs_default_template_images';
export const INHERITABLE_MOBILE_SETTINGS = Object.freeze(['background_color', 'background_image', 'background_image_type', 'body_border_color', 'body_border_width', 'body_color']);
export const LAYOUT_PADDING = {
  DEFAULT_X: 10,
  DEFAULT_Y: 20
};
export function generatePadding(pairs) {
  return Object.entries(pairs).reduce((prev, [key, value]) => {
    if (!isNullOrUndefined(value)) {
      prev[key] = {
        units: 'px',
        value
      };
    }
    return prev;
  }, {});
}
export function generateHorizontalPadding(value) {
  return generatePadding({
    left: value,
    right: value
  });
}
export function generateVerticalPadding(value) {
  return generatePadding({
    top: value,
    bottom: value
  });
}
export const getEffectiveSectionBackgroundColor = (isBoxed, boxedMode, sectionBackgroundColor, bodyColor) => {
  if (sectionBackgroundColor) {
    return sectionBackgroundColor;
  }
  if (sectionBackgroundColor === '' || !isBoxed && boxedMode) {
    return ''; // transparent to background color
  }
  return bodyColor;
};
function hexToRgb(hex) {
  let hexCode = hex;
  if (!hexCode) return {
    r: 255,
    g: 255,
    b: 255
  };
  if (/^#?([a-f\d]{1})([a-f\d]{1})([a-f\d]{1})$/i.test(hexCode)) {
    const hexC = hexCode.length === 4 ? hexCode.substring(1).split('') : hexCode.substring(0).split('');
    hexCode = `${hexC[0]}${hexC[0]}${hexC[1]}${hexC[1]}${hexC[2]}${hexC[2]}`;
  }
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexCode);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : {
    r: 255,
    g: 255,
    b: 255
  };
}
export function getTransparentBackgroundColor(backgroundColor) {
  const rgb = hexToRgb(backgroundColor);
  return `rgba(${rgb.r},${rgb.g},${rgb.b},0.5)`;
}
export function hasBackgroundImage(backgroundImage) {
  return !!backgroundImage && backgroundImage !== 'none';
}
export function pxToInt(value) {
  return value ? Number(value.replace('px', '')) : 0;
}
export function compileStylesheet(stylesheet, context) {
  const path = '[a-z0-9_$][\\.a-z0-9_]*';
  const pattern = new RegExp(`{{\\s*(${path})\\s*}}`, 'gi');
  const UNDEF = '__UNDEF__';
  const result = stylesheet.replace(pattern, (_, token) => {
    const keypath = token.split('.');
    let lookup = context;
    for (let i = 0; i < keypath.length; i++) {
      const key = keypath[i];
      if (key === '__proto__' || key === 'constructor' || key === 'prototype' || !lookup || !Object.prototype.hasOwnProperty.call(lookup, key)) {
        return UNDEF;
      }
      lookup = lookup[key];
      if (i === keypath.length - 1) {
        if (lookup === null || lookup === undefined || lookup === '') {
          return UNDEF;
        }
        return lookup;
      }
    }
    return UNDEF;
  });
  return result.split('\n').filter(line => line.indexOf(UNDEF) === -1).join('\n');
}
export const getDefaultPatternsHelper = () => {
  return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(num => {
    num = num < 10 ? `0${num}` : num;
    const extension = num % 3 === 0 ? 'jpg' : 'png';
    return {
      imagePath: [DEFAULT_IMAGES_PATH, 'email_dnd_background_images', `Pattern-1-${num}.${extension}`].join('/'),
      type: num % 3 === 0 ? 'STRETCH' : 'REPEAT'
    };
  });
};
export const getDefaultPatternFileName = url => {
  var _url$match;
  return (_url$match = url.match(/Pattern-\d+-\d+/)) === null || _url$match === void 0 ? void 0 : _url$match[0];
};